import React from 'react';
import { createRoot } from 'react-dom/client';
import merge from 'lodash.merge';
import PlayerUI from './controls';
import HipsterPlayer from './player/coreplayer';
import defaultMessages from './controls/Player/locale';
import { defaultTheme } from './controls/Player/theme';

const defaultOptions = {
  mini: false,
  seekStepInSeconds: 15, // seconds
  controlsHideDelay: 2500, // ms
  hide: {},
};

export default class MagineMediaPlayer extends HipsterPlayer {
  static DEFAULT_MESSAGES = defaultMessages;
  static DEFAULT_THEME = defaultTheme;

  _hasControls = false;
  reactRoot;

  async renderControls(options) {
    if (!this.reactRoot) {
      this.reactRoot = createRoot(this.playerControlsContainer);
    }
    await this.reactRoot.render((
      <PlayerUI
        player={this}
        options={merge({}, defaultOptions, options)}
      />
    ));

    this._hasControls = true;
  }

  async removeControls() {
    if (!this._hasControls) {
      return;
    }

    await this.reactRoot.unmount();
    this.reactRoot = null;
    this._hasControls = false;
  }

  async destroy() {
    await this.removeControls();
    super.destroy();
  }
}
